import { categories } from "@/mocks/manga";

export default function CategorySection() {
  return (
    <section id="category" className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10 flex-wrap gap-4">
          <div>
            <p className="text-xs tracking-widest text-primary-400 mb-2">猎奇频道 · 题材细分</p>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
              六大暗黑题材
            </h2>
          </div>
          <a
            href="#hot"
            className="inline-flex items-center gap-1.5 text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
          >
            看看大家都在读什么
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href="#hot"
              className="group relative rounded-lg overflow-hidden aspect-[3/4] block"
            >
              <img
                src={cat.image}
                alt={`歪歪漫画${cat.name}分类`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/95 via-background-950/40 to-transparent"></div>
              <div className="absolute inset-0 p-3 flex flex-col justify-end">
                <span className="w-8 h-8 rounded-md bg-primary-600/80 flex items-center justify-center text-foreground-950 mb-2">
                  <i className={`${cat.icon} text-base`}></i>
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {cat.name}
                </h3>
                <p className="text-[11px] text-foreground-400 mt-0.5 line-clamp-2">{cat.desc}</p>
                <p className="text-[11px] text-accent-400 mt-1.5">{cat.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}